import type { ReactElement } from "react";
import { cloneElement } from "react";
import { cn } from "../../lib/utils";

interface NucleoIconProps {
  icon: ReactElement<{ className?: string }>;
  className?: string;
}

/**
 * Wrapper for nucleo-glass icons.
 * In light mode, tints them with the accent color automatically.
 * Pass-through in dark mode (inherits parent color as usual).
 */
export function NucleoIcon({ icon, className }: NucleoIconProps) {
  return cloneElement(icon, {
    className: cn("nucleo-icon", icon.props.className, className),
  });
}
